module.exports = __webpack_public_path__ + "img/rjdl.7c42fc72.png";